import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

export default function SideMenuWidget({ title, data, selectedCategory }) {
  return (
    <>
      <h4 className="cs-sidebar_widget_title">{title}</h4>
      <ul>
        <li>
          <Icon icon="material-symbols:keyboard-double-arrow-right-rounded" />
          <Link 
            to="/blog" 
            style={{ 
              fontWeight: !selectedCategory ? 'bold' : 'normal',
              color: !selectedCategory ? 'var(--primary-color)' : 'inherit'
            }}
          >
            All Posts
          </Link>
        </li>
        {data?.map((item, index) => {
          const isSelected = selectedCategory === String(item.id);
          return (
            <li key={index}>
              <Icon icon="material-symbols:keyboard-double-arrow-right-rounded" />
              <Link 
                to={`/blog?category=${item.id}`}
                style={{ 
                  fontWeight: isSelected ? 'bold' : 'normal',
                  color: isSelected ? 'var(--primary-color)' : 'inherit'
                }}
              >
                {item.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}
